
type CustomerSupportPromoProps = {
    showExtraInfo?: boolean
}

const CustomerSupportPromo = ({ showExtraInfo }: CustomerSupportPromoProps) => {



    return <div className="card mt-4"><div className="card-body d-flex gap-4 align-items-center ms-2 me-2">
        <div>
            <img src="/min-bedrift-ill-hjelp.svg" width="980" height="1748" style={{ width: "80px", height: "auto", display: "block" }} alt=""></img>
        </div>
        <div>
            <h2 className="h3">Trenger du hjelp?</h2>
            <p className="text-secondary">Har du spørsmål om endringer, innlogging eller hva du kan gjøre på <span className="d-inline-block">Min bedrift?</span></p>
            <ul className="list-unstyled mb-0">
                {showExtraInfo ? <li><a href="https://kundeservice.1881.no/support/solutions/articles/158000411673-hvorfor-ser-jeg-ingen-bedrifter-i-min-oversikt-pa-min-bedrift-">Hvorfor ser jeg ingen bedrifter?</a></li> : null}
                <li><a href="https://kundeservice.1881.no/support/solutions/158000511732">Se våre hjelpesider</a></li>
            </ul>
        </div>
    </div></div>
}

export default CustomerSupportPromo;